export class PriceLabelDet {
    priceLabelId: number;
    positionCode: string;
    priceLabelSecId: number = -1;
}